import React from "react";
import { CustomerSelectionFormControl } from "../../../../components/form/CustomerSelectionFormControl/CustomerSelectionFormControl";

export function CustomersTab(props) {
    const { control, fieldName, readOnly } = props;

    return (
        <CustomerSelectionFormControl control={control} fieldName={fieldName} readOnly={readOnly} />
    );
}
